import { combineReducers } from "redux";
import * as types from "./types";

const defaultPanel = {
  type: false,
  data: { isbn: false, tab: false, title: false }
};

const panelReducer = (state = defaultPanel, action) => {
  switch (action.type) {
    case types.CLOSE_PANEL:
      return defaultPanel;
    case types.OPEN_PANEL:
      return {
        type: action.data.type,
        data: action.data
      };
    case types.CHANGE_PANEL_TAB:
      return {
        ...state,
        data: { ...state.data, tab: action.tab }
      };
    case types.UPDATE_BOOK_GRID_VIEW:
      return {
        data: { category: action.category, title: action.title }
      };
    default:
      return state;
  }
};

const mobileMenuReducer = (state = false, action) => {
  switch (action.type) {
    case types.TOGGLE_MOBILE_HEADER_MENU:
      return !state;
    case types.CLOSE_MOBILE_HEADER_MENU:
      return false;
    default:
      return state;
  }
};

const libraryReducer = combineReducers({
  panel: panelReducer,
  mobileMenu: mobileMenuReducer
});

export default libraryReducer;
